import { Input } from "@deligoo/ui"
import clsx from "clsx"
import { ComponentProps } from "react"

import { PACKAGES_ASSETS } from "@/assets/packages"
import { PackageType } from "@/types"

import cls from "./PackageCard.module.scss"

const PACKAGE_LABELS = {
  "big-pizza": { label: "Duża pizza", sublabel: "32cm+" },
  "standard-dish": { label: "Danie standard", sublabel: "pizza do 32cm" },
  "own-packaging": { label: "Opakowanie własne", sublabel: "sushi / zakupy" },

  "hebe-box-1": { label: "BOX 1", sublabel: "16,5 cm x 13,5 cm x 9 cm" },
  "hebe-box-2": { label: "BOX 2", sublabel: "28 cm x 17 cm x 9,5 cm" },
  "hebe-box-3": { label: "BOX 3", sublabel: "37 cm x 25 cm x 9,5 cm" },
  "hebe-box-4": { label: "BOX 4", sublabel: "37 cm x 25 cm x 19 cm" },
  "hebe-box-5": { label: "BOX 5", sublabel: "44 cm x 32 cm x 2,5 cm" },

  "ecommerce-size-a": { label: "Gabaryt A", sublabel: "maks. 8 cm x 38 cm x 64 cm" },
  "ecommerce-size-b": { label: "Gabaryt B", sublabel: "maks. 19 cm x 38 cm x 64 cm" },
  "ecommerce-size-c": { label: "Gabaryt C", sublabel: "maks. 41 cm x 38 cm x 64 cm" },

  "inpost-size-a": { label: "Gabaryt A", sublabel: "8 cm x 38 cm x 64 cm" },
  "inpost-size-b": { label: "Gabaryt B", sublabel: "19 cm x 38 cm x 64 cm" },
  "inpost-size-c": { label: "Gabaryt C", sublabel: "41 cm x 38 cm x 64 cm" },
} as const

type PackageCardProps = {
  type: PackageType
  value: number
  setValue: (value: number) => void
  inputProps?: ComponentProps<typeof Input>
  className?: string
}

export const PackageCard = ({ type, value, setValue, inputProps, className }: PackageCardProps) => {
  return (
    <div
      className={clsx(cls.packageType, value > 0 && cls.selected, className)}
      onClick={(e) => {
        e.stopPropagation()
        setValue(value + 1)
      }}
    >
      <div className={cls.packageInfo}>
        <img className={cls.packageImg} src={PACKAGES_ASSETS[type]} alt="" />
        <div className={cls.packageLabel}>
          <div className="text-muted">{PACKAGE_LABELS[type].label}</div>
          <div className={cls.sublabel}>{PACKAGE_LABELS[type].sublabel}</div>
        </div>
      </div>

      <Input
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setValue(Number(e.currentTarget.value))}
        value={value}
        type="number"
        min={0}
        selectOnFocus
        plain
        {...inputProps}
      />
    </div>
  )
}
